import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// noinspection SpellCheckingInspection
export const i18nConfig = {
  interpolation: { escapeValue: false },
  supportedLngs: ['en-US', 'en-CA', 'en-BG', 'en-AU', 'fr-CA'],
  fallbackLng: 'en-US',
} as const;

let hasInitialized: boolean = false;

/**
 * Initialize i18next for the app.
 * Safe to call multiple times; only the first call does work.
 */
export function initI18n(): void {
  if (hasInitialized) return;
  hasInitialized = true;

  void i18next
    .use(initReactI18next)
    .use(HttpApi)
    .use(LanguageDetector)
    .init(i18nConfig);
}

initI18n();

export default i18next;